export default function initTableShadows() {
  const $threats = $('#threats');
  const startElem = document.querySelector('.table-list__start');
  const endElem = document.querySelector('.table-list__end');

  const tableStartObserver = new IntersectionObserver((items) => {
    items.forEach((item) => {
      if (item.isIntersecting) {
        $threats.removeClass('table-before-active');
      } else {
        $threats.addClass('table-before-active');
      }
    });
  });

  const tableEndObserver = new IntersectionObserver((items) => {
    items.forEach((item) => {
      if (item.isIntersecting) {
        $threats.removeClass('table-after-active');
      } else {
        $threats.addClass('table-after-active');
      }
    });
  });

  if (startElem && endElem) {
    tableStartObserver.observe(startElem);
    tableEndObserver.observe(endElem);
  }
}
